import { ref } from 'vue'
import type { ReadonlyRef } from '@/helpers'

export interface FilterModal {
    isFilterModalOpen: ReadonlyRef<boolean>
    isFilterModalRendered: ReadonlyRef<boolean>
    openFilterModal(): void
    closeFilterModal(): void
}

export function useFilterModal(): FilterModal {
    const isFilterModalOpen = ref(false)
    const isFilterModalRendered = ref(false)

    function openFilterModal(): void {
        isFilterModalOpen.value = true
        isFilterModalRendered.value = true
    }

    function closeFilterModal() {
        isFilterModalOpen.value = false
    }

    return {
        isFilterModalOpen,
        isFilterModalRendered,
        openFilterModal,
        closeFilterModal,
    }
}
